( function( app ) {
  const COMPONENT = {
    className: 'll-mpf',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      const _this = this;
      const pages = $( '.gform_page' );
      let currentPageIndex = 0;
      let displayPg = 1;


      // get total number of pages and remove any pages that are just message pages
      const pageTotal = $( '.mpf__stepper-total' ).html( pages.length - $( '.mpf__message' ).length );
      const pageCurrent = $( '.mpf__stepper-current' );
      $( pageCurrent ).html( displayPg );

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        currentPageIndex = parseInt( currentPage ) - 1;
        const curPage = $( `#gform_page_${formId}_${currentPage}` );

        if ( $( curPage ).hasClass( 'mpf-skip-page' ) ) {
          $( '.llgq-quoter-next' ).removeClass( 'llgq-radio-page-hidden' );
        }

        const message = $( curPage ).find( '.mpg__message-name' );
        const name = $( $( '.mpf-name' ).get( 0 ) ).find( 'input' ).val();
        if ( $( message ).length !== 0 && name !== '' ) {
          $( message ).html( `, ${name}!` );
        }

        $( '.gform_next_button' ).on( 'click', function( event ) {
          if ( !$( $( pages )[currentPageIndex + 1] ).hasClass( 'mpf-message-page' ) ) {
            displayPg += 1;
            $( pageCurrent ).html( displayPg );
          }
        } );
      } );

      $( '.gform_next_button' ).on( 'click', function( event ) {
        if ( !$( $( pages )[currentPageIndex + 1] ).hasClass( 'mpf-message-page' ) ) {
          displayPg += 1;
          $( pageCurrent ).html( displayPg );
        }
      } );

      $( '.llgq-quoter-back' ).on( 'click', function( event ) {
        // check if the current page has the class if so don't do anything
        // if the next page has the class subtract two
        // if th enext does not subtract one

        if ( !$( $( pages )[currentPageIndex] ).hasClass( 'mpf-message-page' ) ) {
          displayPg -= 1;
          $( pageCurrent ).html( displayPg );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'll-mpf', COMPONENT );
} )( app );
